import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { PersonViewService } from './person.view.service';
import { FormControl, FormGroup } from '@angular/forms';
import { DateAdapter } from '@angular/material';
import { AppService } from '../../app.service';
import { ConfirmService } from '../../shared/confirm/confirm.service';
import { Countries } from '../../shared/countries/countries';
import { ActivatedRoute } from '@angular/router'; 
import { Globals } from '../../globals';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { Formvalidator } from '../PersonFormComponent/person.form.formvalidator';
import { HttpResponse } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import translateJson from "../../../translate.json";
import customerJson from "../../../assets/config/customer.json";
import { EmployerType } from '../../shared/enum/EmployerType'
import { ArchiveModalComponent } from '../../shared/views/ArchiveModalComponent/archive.modal.component';
import { ErrorModalComponent } from '../../shared/views/ErrorModalComponent/error.modal.component';
import { FileUploader, FileLikeObject } from 'ng2-file-upload';
import { ValidationModalComponent } from '../../shared/views/ValidationModalComponent/validation.modal.component';
import { EntityTypes } from '../../shared/enum/EntityTypes';
import { merge } from 'rxjs';
import { DateUpdateFix } from '../../models/date-update-fix';
import { AuthenticationService } from '../../auth';

enum pageTypeEnum {Main, Search, New, Edit, View};
enum otherTypeEnum {Employer, Project, RK, FAS};
enum addressType {NATIONAL, INTERNATIONAL, FELLOWAPPLICANT};
enum attachmentOtherTypeEnum {Attachment, PersonClearanceCallAttachment};

@Component({
  selector: 'person-comp',
  providers: [PersonViewService, AppService, Formvalidator, ConfirmService, NgxSmartModalService, Countries, DateUpdateFix, AuthenticationService],
  templateUrl: './person.view.component.html',  
  styleUrls: ['../person.component.css']  
})

export class PersonViewComponent {

  @ViewChild('validationModal') validationModal: ValidationModalComponent;
  @ViewChild('errorModalComponent') errorModalComponent: ErrorModalComponent;
  
  @ViewChild('pdfAttachmentViewer') pdfAttachmentViewer;

  @ViewChild('archiveModal') archiveModal: ArchiveModalComponent;
  // Get translation/text from customerJson
  private i18 = translateJson.i18;
  private customerOrgId: String = customerJson.customer.organisationId
  private globalOrgAssociations: boolean = customerJson.settings.globalOrgAssociations;
  private showGenderField: Boolean = customerJson.settings.showGenderField;
  private approvedDateField: String = customerJson.settings.personRkTableApprovedColumn;
  private approvedDateFieldHeader: String = customerJson.settings.personRkTableApprovedColumnHeader;
  private edition: String = customerJson.edition;
  private rolesAndPermissions: Boolean = false;
  private notSpecified: String = "";

  private person: any;
  private noRk: Boolean = false;
  rkNotSent: any = [];
  rkSent: any = [];
  rkApproved: any = [];
  registerControl: any = [];

  employers: any = [];
  projects: any = [];
  projectName: String;
  otherType: String = otherTypeEnum[customerJson.settings.defaultTypeShown];
  showLoader: Boolean = false;
  showPersonDetailsVar: Boolean = true;
  showOtherDetailsVar: Boolean = true;
  showNotesDetailsVar: Boolean = true;
  showFellowApplicantDetailsVar: Boolean = true;
  showDateDetailsVar: Boolean = true;
  showGroupDetailsVar: Boolean = true;
  showRegisterDetailsVar: Boolean = true;  
  showNoteEditorVar: Boolean = false; 

  column: String;
  isDesc: Boolean; 
  filteredEmployer: String;
  filteredProject: String; 

  addressForm: FormGroup;
  addressIntForm: FormGroup;
  personForm: FormGroup;  
  attachmentForm: FormGroup;
  fasAvailable: Boolean = false;
  
  ministryArray:any = [];
  govMinistryName: String;
  govEntityName: String;
  govSectionName: String;
  showMinistryDetailsVar: Boolean = true;
  employedByCustomer: Boolean = false;
  allowNoSsn: Boolean = customerJson.settings.allowNoSsn
  selectedOrgAssociation: Number;
  selectedGroup: Number;
  id: String;
  personCountryCodeNames: String;

  showSecurityActivityDateFields: Boolean = true;
  securityActivityDateAvailableBool: Boolean = false;
  numOfNotes:number = 0;

  private restorePersonError = {
    header: this.i18.person.form.archivePersonRestoreErrorHeader,
    title: this.i18.person.form.archivePersonRestoreErrorTitle,
    message: this.i18.person.form.archivePersonRestoreErrorMessage
  }

  // Attachment related variables
  public uploader: FileUploader = new FileUploader({allowedFileType: ["pdf"]});
  currentFileUpload: FileLikeObject;
  private newAttachment: Boolean = false;
  showAttBody: Boolean = false;
  selectedFiles: FileList;
  private attachmentContent: any;
  private showContentForAttachment: Boolean = false;
  public latestSecurityClearanceCallDate;
  securityAgrementCheckbox: Boolean = false;
  attachmentOtherType: String = attachmentOtherTypeEnum[0];
  noAttachmentForPerson: Boolean = false;
  noPersonClearanceCallAttachment: Boolean = false;
  entityType = EntityTypes;

  pdfBlob: any = null;
  pdfName: string = null;
  currentPdfView: string = '';

  /**
   * Constructor
   * @param service         Service for this view
   * @param formValidator   Validation class
   * @param appService      General service for whole app
   * @param confirmService  Service for confirm modal
   * @param activatedRoute  Route for the URL
   * @param location        To be able to go back to previous view
   * @param countries       List of all countries and their countrycodes
   */
  constructor(
    private service: PersonViewService,
    private ngxSmartModalService: NgxSmartModalService,
    private formValidator: Formvalidator,
    private sanitizer: DomSanitizer,
    private appService: AppService,
    private confirmService: ConfirmService,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private countries: Countries,
    private dateUpdateFix: DateUpdateFix,
    private globals: Globals,
    private dateAdapter: DateAdapter<Date>,
    private authService: AuthenticationService) {
      this.authService.isAuthenticated();
      this.fasAvailable = appService.isComponentActive('securityAgreement');
      this.id = this.activatedRoute.snapshot.paramMap.get('id');
      this.setDefault();
      this.rolesAndPermissions = this.globals.rolesAndPermissions;
      this.notSpecified = this.i18.orgAssociation.notSpecified;
  }   

  /**
   * Initiate all fields
   */
  setDefault() {
    this.dateAdapter.setLocale('sv');
    this.getPerson(this.id); 

    this.addressForm = new FormGroup({
      id: new FormControl(),
      address_1: new FormControl(), 
      address_2: new FormControl(),
      postCode: new FormControl(),
      city: new FormControl(),
      countryCode: new FormControl()
    });

    this.addressIntForm = new FormGroup({
      id: new FormControl(),
      address_1: new FormControl(),
      address_2: new FormControl(),
      postCode: new FormControl(),
      city: new FormControl(),
      countryCode: new FormControl()
    });

    this.attachmentForm = new FormGroup({
      securityClearanceCallDateControl: new FormControl()
    })
  }

  /**
   * Go back to person search
   */
  back() {
    this.appService.setRoute("/person");
  }

  /**
   * Set the URL-route to the specified route
   * @param route Route to change to
   */
  setRoute(route) {
    this.appService.setRoute(route);
  }

  /**
   * Set other type
   * @param type type of page
   */
  setOtherType(type) {
    this.otherType = otherTypeEnum[type];
    if(this.otherType == 'Employer') {
      this.getEmployers();
    } else if (this.otherType == 'Project') {
      //this.getProjects();
    } else if (this.otherType == 'RK') {
      this.getRkByPersonId(this.id);
    }
  }

  getRkByPersonId(personId) {
    this.service.getRkByPersonId(personId)
      .subscribe(
        data => this.setRk(data),
        error => this.showError(error.error)
      )
  }

  setRk(data) {   
    this.registerControl = data;
    this.setRkModal();
    this.setRkInfoTooltip();
  }

  /**
   * Set rk tooltip
   */
  setRkInfoTooltip() {
    for(let i=0; i<this.registerControl.length; i++) {
      this.registerControl[i]["rkInfoTooltip"] = this.buildRkInfoTooltip(i);
    }
  }

  /**
   * Construct tool tip for each RK displayed for a specific person
   * @param index
   * @returns
   */
  buildRkInfoTooltip(index: any) {
    let rkInfoTooltip: String = "";
    if(this.edition == "company") {
      if (this.person.registerControl[index].operatorName != undefined && this.person.registerControl[index].operatorName.length > 0) {
        rkInfoTooltip = this.i18.rk.form.rkOperatorMainLabel + ": " + this.person.registerControl[index].operatorName + "\n";
      }
    }

    if (this.person.registerControl[index].orgAssociation != null) {
      if(this.person.registerControl[index].orgAssociation.department != undefined) {
        rkInfoTooltip += this.i18.goverment.form.govermentPart1Label + ": " + this.person.registerControl[index].orgAssociation.department + "\n";
      }

      if(this.person.registerControl[index].orgAssociation.entity != undefined) {
        rkInfoTooltip += this.i18.goverment.form.govermentPart2Label + ": " + this.person.registerControl[index].orgAssociation.entity + "\n";
      }

      if(this.person.registerControl[index].orgAssociation.section != undefined) {
        rkInfoTooltip += this.i18.goverment.form.govermentPart3Label + ": " + this.person.registerControl[index].orgAssociation.section + "\n";
      }
    }

    return rkInfoTooltip;
  }

  setRkModal() {
    if(this.registerControl.length === 0) {
      this.noRk = true;
      return;
    }
    for(let i=0; i < this.registerControl.length; i++){
      if(this.registerControl[i].status == 'Ej skickad') {
        this.rkNotSent.push(this.registerControl[i]);
      } else if(this.registerControl[i].status  == 'Skickad') {
        this.rkSent.push(this.registerControl[i]);
      } else if(this.registerControl[i].status == 'Godkänd') {
        this.rkApproved.push(this.registerControl[i]);
      }
      this.registerControl[i].projectName = this.getProjectNameById(this.registerControl[i].suaId)
    }
    // Update RK on objects for template
    this.person.registerControl = this.registerControl;
  }

  openRkModal(type) {
    if(type == 'Skickad') {
      this.ngxSmartModalService.setModalData(this.rkSent, 'rkModal', true);
    } else if(type == 'Ej skickad') {
      this.ngxSmartModalService.setModalData(this.rkNotSent, 'rkModal', true);
    } else if(type == 'Godkänd') {
      this.ngxSmartModalService.setModalData(this.rkApproved, 'rkModal', true);
    }
    this.ngxSmartModalService.getModal('rkModal').open();
  }

  /**
   * Get all employers
   */
  getEmployers() {      
    this.service.getAllEmployers()
      .subscribe(
        data => this.filterSelectedEmployers(data),
        error => this.showError(error.error)       
      )
  }

  /**
   * Get all projects
   */
  getProjects() {
    this.service.getAllProjects()
      .subscribe(
        data => this.filterSelectedProjects(data),
        error => this.showError(error.error)
      )
  }

  /**
   * Retrieve existing person
   * @param person person object
   */
  getPerson(id) {
    this.service.getPersonById(id)      
      .subscribe(
        data => this.displayPerson(data),
        error => this.showError(error.error),  
        () => this.showLoader = false      
      );       
  }

  /**
   * Display a selected person
   * @param person person object
   * @param type page type number
   */
  displayPerson(person) {
    this.person = person;
    if(this.person.ssn == null || this.person.ssn === ''){
      this.person.ssn = this.i18.person.form.noSSNDeclared;
    }
    
    this.getEmployer();
     // this.getProjects();
    this.getRkByPersonId(this.person.id);
    this.setPersonAndAddresses();

    if (this.person.orgAssociations.length != null && this.person.orgAssociations.length > 0) {
      this.selectedOrgAssociation = 0;
    }

     if (this.person.groupsList.length != null && this.person.groupsList.length > 0) {
      this.selectedGroup = 0;
    }
    this.getLatestSecurityCallAttachmentDate(this.person);
    this.checkForAttachmentType(this.person);
    this.securityActivityDateAvailable();
    // set the number of notes on first load. this will then be updated when a user adds/removes notes
    this.numOfNotes = this.person.notes.length;

    this.personCountryCodeNames = this.countries.get2CountryCodeNames(person.nationalityCode);    
  }

  /**
   * Set person and addresses to forms
   */
  setPersonAndAddresses() {    
    for(let i = 0; i < this.person.addresses.length; i++) {
      if (this.person.addresses[i].addressType == addressType[0]) {
        this.addressForm.patchValue({
          id: this.person.addresses[i].id,
          address_1: this.person.addresses[i].address_1,
          address_2: this.person.addresses[i].address_2,
          postCode: this.person.addresses[i].postCode,
          city: this.person.addresses[i].city,
          countryCode: this.person.addresses[i].countryCode
        })
      } else if (this.person.addresses[i].addressType == addressType[1]) {
        this.addressIntForm.patchValue({
          id: this.person.addresses[i].id,
          address_1: this.person.addresses[i].address_1,
          address_2: this.person.addresses[i].address_2,
          postCode: this.person.addresses[i].postCode,
          city: this.person.addresses[i].city,
          countryCode: this.person.addresses[i].countryCode
        });
      }
    }
    this.setAddressTypeView(0);
  }

  /**
   * Set tab view for address
   * @param type type of address
   */
  setAddressTypeView(type) {
    this.person.addressTypeView = addressType[type];
  }

  /**
   * Archives a person given a specified personId
   * @param personId persons unique identifier
   */
  archivePerson(personId) {
    // Setup entity
    let entityObject = this.archiveModal.createEntityObject(this.entityType.PERSON, personId,[]);

    // Setup object (rk in this case)
    let object = this.archiveModal.setupDefaultRkData();

    // Setup data objects specific for entity, in this case for RK
    if(this.person.registerControl != null || this.person.registerControl != undefined) {
      //Bug prevention. Manually count active RK
      let rkCount = 0;
      for(let i=0; i<this.person.registerControl.length;i++) {
        let rk = this.person.registerControl[i];
        // Push each rk information as data object
        if(!rk.archived) {
          rkCount++;
          object.objectArray.push(this.archiveModal.createModalObject(rk.rkRegNumber,rk.status,rk.purposeOfControl));
        }
      }
      //If no RK was found we skip returning anything. Otherwise we would still get an empty promt!
      if(rkCount > 0){
        // Push our data objects to the entity
        entityObject.dataArray.push(object);
      }
    }


    // Setup entity and prepare to show modal
    this.archiveModal.setEntityData(entityObject);

    // Display modal
    this.archiveModal.pop()
  }

  /**
   * Restores a soft deleted person
   * @param personId persons unique identifier
   */
  restoreArchivedPerson(personId) {
    let canRestore:boolean = true;
    for(let i = 0; i < this.person.employers.length; i++) {
      if(this.person.employers[i].archived) {
        canRestore = false;
      }
    }

    if(!canRestore) {
      this.showErrorModal(this.errorModalComponent.getErrorModalArray(), this.restorePersonError)
    } else {
      this.confirmService.confirm(this.i18.person.form.confirmUnarchive + ' ' + this.person.firstName+' '+this.person.lastName+'?')
        .then(result => {
          if (result) {
            this.service.restoreSoftDeletedPerson(personId)
            .subscribe(
              data => this.displayPerson(data),
              error => this.showError(error.error)
            )
          }
        });
      }
    }

  /**
   * Show error modal
   * @param modalData modalData array
   * @param error error msg
   */
  showErrorModal(modalData, error) {
      modalData[0] = error.header;
      modalData[1] = error.title;
      modalData[2] = error.message;
      this.errorModalComponent.pop();
  }

  /**
   * Get employer mapped to the person   
   */
  getEmployer() {
    this.filterSelectedEmployers(this.person.employers);    
  }

  /**
   * Filter person employers as selected
   * @param employers 
   */
  filterSelectedEmployers(employers) {
    for (let i = 0; i < employers.length; i++) {      
      for(let j = 0; j < this.person.employers.length; j++) {
        if (employers[i].id == this.person.employers[j].id) {
          employers[i].selected = true;
          break;
        } 
      }      
    }

    this.employers = employers;
    
    for(let k = 0; k < this.employers.length; k++){
      if(this.employers[k].organisationId === this.customerOrgId && this.employers[k].selected === true){
        this.employedByCustomer = true;
      }  
    }
    
  }
  

  /**
   * Filter person projects as selected
   * @param projects 
   */
  filterSelectedProjects(projects) {
    for (let i = 0; i < projects.length; i++) {         
      for(let j = 0; j < this.person.projects.length; j++) {
        if (projects[i].id == this.person.projects[j].id) {
          projects[i].selected = true;
          break;
        } 
      }      
    }
    this.person.projects = this.projects = projects;
  }

  /**
   * Show/Hide person details
   */
  showPersonDetails() {
    this.showPersonDetailsVar = !this.showPersonDetailsVar;
  }

  /**
   * Show/Hide other details
   */
  showOtherDetails() {
    this.showOtherDetailsVar = !this.showOtherDetailsVar;
  }

   /**
   * Show/Hide fellowApplicant details
   */
  showFellowApplicantDetails() {
    this.showFellowApplicantDetailsVar = !this.showFellowApplicantDetailsVar;
  }

  /**
   * Show/Hide date details
   */
  showDateDetails() {
    this.showDateDetailsVar = !this.showDateDetailsVar;
  }

  /**
   * Show/Hide register details
   */
  showRegisterDetails() {
    this.showRegisterDetailsVar = !this.showRegisterDetailsVar;
  }

  /**
   * Show error
   * @param error error text
   */
  showError(error) {
    this.showLoader = false;
    this.confirmService.error(error.message);
  }

  /**
   * Show error thrown when editing notes
   * @param error error text
   */
  showNoteError(error) {
    this.confirmService.error(this.appService.getTranslatedErrorMessage(error));
  }
  
  /**
   * Sort columns
   * @param property 
   * @param data 
   */
  sort(property, data){
    this.isDesc = !this.isDesc; //change the direction    
    this.column = property;
    let direction = this.isDesc ? 1 : -1;

    data.sort(function(a, b){
        if(a[property] < b[property]){
            return -1 * direction;
        }
        else if( a[property] > b[property]){
            return 1 * direction;
        }
        else{
            return 0;
        }
    });
  };

  getProjectNameById(projectId)
  {
    for (const project of this.projects) {
      if(project.id == projectId)
      {
        return project.compProjectName;
      }
    };

    return false;
  };
  
  /**
   * Show/Hide Ministry details
   */
  showMinistryDetails() {
    this.showMinistryDetailsVar = !this.showMinistryDetailsVar;
  }

  /**
   * Getter for the person's orgAssociations array
   */
  get orgAssociations(): Array<any> {
    return this.person.orgAssociations;
  }

    /**
   * Getter for the person's groups array
   */
     get groupsList(): Array<any> {
      return this.person.groupsList;
    }

  /** Attachment related methods
  */
  showAttachment() {
    this.ngxSmartModalService.getModal('attachmentModal').open();
  }

  /*ngAfterViewInit() {
    this.ngxSmartModalService.getModal('attachmentModal').onDismiss.subscribe((modal: NgxSmartModalComponent) => {
      // modal is the dismissed modal, so do what you want with it
      this.resetModal();
    });
  }*/

  /**
   * reset attachment modal
   */
  resetModal() {
    this.newAttachment = false;
    this.showAttBody = false;
    this.securityAgrementCheckbox = false;
    this.uploader.clearQueue();
    this.clearPreview();
  }

  showAttachmentBody() {
    this.showAttBody = true;
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  showUploader() {
    this.newAttachment = true;
  }

  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }



  /**
  * upload attachments for person
  * @param securityClearanceCallDate date for securityclearance interview
  */
  upload(securityClearanceCallDate) {
    let files = this.getFiles();
    if(!this.securityAgrementCheckbox){
      for(let i=0; i < files.length; i++) {
        let formData = new FormData();
        formData.append('file', files[i].rawFile, files[i].name);
        this.service.upload(formData).subscribe(event => {
          if(event.status != 200) {
            return;
          }
          if(event instanceof HttpResponse) {
            let personAttachment = {
              readableName: files[i].name,
              uploadedDate: null,
              attachmentType: "personAttachment"
            }
            this.service.saveAttachment(personAttachment, "person", this.person.id).subscribe(
              data => this.uploadReady(),
              error => console.log(error)
            )
          }
        })
      }
    }
    else if (this.securityAgrementCheckbox && !this.formValidator.validateSecurityClearanceCallDate(securityClearanceCallDate, this.validationModal.getModalArray())) {
      for(let i=0; i < files.length; i++) {
        let formData = new FormData();
        formData.append('file', files[i].rawFile, files[i].name);
        this.service.upload(formData).subscribe(event => {
          if(event.status != 200) {
            return;
          }
          if(event instanceof HttpResponse) {
            let personAttachment = {
              readableName: files[i].name,
              uploadDate: this.dateUpdateFix.fixDateOnUpdate(securityClearanceCallDate),
              attachmentType: "personSecurityCallAttachment"
            }
            this.service.saveAttachment(personAttachment, "person", this.person.id).subscribe(
              data => this.uploadReady(),
              error => console.log(error)
            )
          }
        })
      }
    }
    else {
      this.validationModal.pop();
    }

  }

  /**
   * Set's a pdf blob to be previewed upon user request
   * @param data pdf to view as blob
   * @param filename readable name of pdf file
   * @param elementId id of html elemet that triggered the preview
   */
  renderAttachment(data, filename, elementId) {
    this.currentPdfView = elementId;
    this.pdfName = filename;
    this.pdfBlob = new File([(data)], filename, {type: 'application/pdf'});
    if(this.pdfAttachmentViewer != undefined && this.pdfAttachmentViewer != null) {
      this.pdfAttachmentViewer.pdfSrc = this.pdfBlob;
      this.pdfAttachmentViewer.refresh();
    }
    this.showContentForAttachment = true;
  }

  /**
   * Closes the latest pdf preview 
   */
  clearPreview() {
    this.currentPdfView = '';
    this.pdfBlob=null;
    this.pdfName=null;
    this.attachmentContent = null;
    this.showContentForAttachment = false;    
  }

  /**
   * sanitize attachment url
   * @param url 
   */
  sanitizeUrl(url) {
    this.attachmentContent = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.showContentForAttachment = true;
  }

  /**
   * Get the attachment and render the preview
   * @param id 
   */
  showAttachedFile(id, filename, elementId) {
    this.service.showAttachedFile(id).subscribe(
      data => this.renderAttachment(data, filename, elementId),
      error => console.log(error)
    );
  }

  /**
   * clear upload and refresh attachment list after attachment upload
   */
  uploadReady() {
    this.getPerson(this.id);
    this.uploader.clearQueue();
    this.newAttachment = false;
    this.setSecurityAttachmentCheckbox();
  }

  /**
   * Delete an attachment
   * @param attachmentId uuid of the attachment
   * @param attachmentName name of the attachment
   */
  deleteAttachment(attachmentId, attachmentName){
    this.confirmService.confirm(this.i18.person.form.confirmDeleteOfAttachement + attachmentName)
      .then(result => {
        if(result) {
          this.service.deleteAttachment(attachmentId, this.id)
            .subscribe(
              data => this.getPerson(this.id),
              error => this.showErrorModal(this.errorModalComponent.getErrorModalArray(), error)
            )
        }
      });
  }

  /**
   * Get the latest date for personSecurityCallAttachments.
   * @param person 
   */
  getLatestSecurityCallAttachmentDate(person) {
    this.latestSecurityClearanceCallDate = null; //Make sure its null if function is called again
    if(person.attachment.length > 0){
      person.attachment.forEach(attachment => {
        if(attachment.attachmentType === 'personSecurityCallAttachment' && (attachment.uploadDate != null && attachment.uploadDate != undefined) && this.dateCompare(attachment.uploadDate)){
          this.latestSecurityClearanceCallDate = attachment.uploadDate;
        }
      });
    }
  }

  /**
   * Compare the upload dates for security call attachments
   * @param date date to compare
   * @returns boolean
   */
  dateCompare(date){
    if(this.latestSecurityClearanceCallDate === null || this.latestSecurityClearanceCallDate === undefined){
      return true;
    } else {
      if(Date.parse(this.latestSecurityClearanceCallDate) < Date.parse(date)){
        return true
      } else {
        return false;
      }
    }
  }

  /**
  * Check attachments array for normal attachments and security clearance attachments
  * The booleans are used to display modaltexts when there are no attachments
  * @param person person object
  */
  checkForAttachmentType(person){
    this.noAttachmentForPerson = person.attachment.some(e => e.attachmentType === 'personAttachment');
    this.noPersonClearanceCallAttachment =  person.attachment.some(e => e.attachmentType === 'personSecurityCallAttachment');
  }

  /**
  * Set other attachment type used for person attachment tabs
  * @param type type of attachment
  */
  setAttachmentType(type) {
    this.attachmentOtherType = attachmentOtherTypeEnum[type];
    this.setSecurityAttachmentCheckbox();
  }

  showSecurityActivityDates(){
    this.showSecurityActivityDateFields = !this.showSecurityActivityDateFields;
  }

  securityActivityDateAvailable() {
    if(this.person.securityActivityDateOne != null
      || this.person.securityActivityDateTwo != null
      || this.person.securityActivityDateThree != null
      || this.person.securityActivityDateFour != null
      || this.person.securityActivityDateFive != null
      || this.person.securityActivityDateSix != null){

        this.securityActivityDateAvailableBool = true;
      } else {
        this.securityActivityDateAvailableBool = false;
      } 
  }

  /**
   * Anchor
   * @param target id
   */
  public anchor(target): void {
    this.appService.scrollToTarget(target);
  }

  /**
   * helper to set the securityAttechment checkbox
   */
  setSecurityAttachmentCheckbox(){
    if(this.attachmentOtherType === 'Attachment'){
      this.securityAgrementCheckbox = false;
    } else if (this.attachmentOtherType === 'PersonClearanceCallAttachment') {
      this.securityAgrementCheckbox = true;
    }
  }

  /**
     * Helper to update the number of notes displayed on top of the page.
     * Checks if the value from the notes component is a number and updates it.
     * If the value is not a number the amount of notes is taken from the notes array received in the initial request.
     * @param numOfNotes 
     */
   setNumOfNotes(numOfNotes: number){
    if(numOfNotes != null && !Number.isNaN(numOfNotes)){
        this.numOfNotes = numOfNotes;
    } else {
        this.numOfNotes = this.person.notes.length;
    }
  }

   /**
   * Show/Hide date details
   */
    showGroupDetails() {
      this.showGroupDetailsVar = !this.showGroupDetailsVar;
    }

    setUpdatedNotes(notes) {
      this.person.notes = notes;
    }
    
    /**
     * Helper to autocomplete a date with missing dividers '-'
     * @param date date string to patch
     * @param form the form to use
     * @param formControlName the formControlName to be patched with the date.
     */
    patchDate(date: string, form: string, formControlName: string) {
      if(date != null) {
          date = date.replace(/-/g,'');
      }
      if((date != null && date.trim() !== '') && 
      (formControlName != null && formControlName.trim() !== '') && date.length >= 8) {
          let yearPossition = 4;
          let monthPossition = 6;
          let dateDivader = '-'
          let patchedDate = date.substring(0,yearPossition) + dateDivader + date.substring(yearPossition, monthPossition) + dateDivader + date.substring(date.length-2, date.length)
          if(form === 'attachmentForm') {
              this.attachmentForm.patchValue({
                  [formControlName]: patchedDate
              })
          }
      }
    }
}